import { HOLIDAY_COMPANY_LIST, HOLIDAY_COMPANY_INFO, HOLIDAY_COMPANY_SAVE } from 'actions/holiday';

function holiday(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case `${HOLIDAY_COMPANY_LIST}_FULFILLED`:
      return {
        ...state,
        holidayCompanyList: payload,
        isPending: false
      };
    case `${HOLIDAY_COMPANY_LIST}_PENDING`:
      return {
        ...state,
        holidayCompanyList: payload,
        isPending: true
      };
    case `${HOLIDAY_COMPANY_LIST}_REJECTED`:
      return {
        ...state,
        holidayCompanyList: { data: { content: [] } },
        isPending: false
      };
    case `${HOLIDAY_COMPANY_INFO}_FULFILLED`:
      return {
        ...state,
        holidayCompanyInfo: payload
      };
    case `${HOLIDAY_COMPANY_INFO}_PENDING`:
      return {
        ...state,
        holidayCompanyInfo: payload
      };
    case `${HOLIDAY_COMPANY_INFO}_REJECTED`:
      return {
        ...state,
        holidayCompanyInfo: payload
      };
    case `${HOLIDAY_COMPANY_SAVE}_FULFILLED`:
      return {
        ...state,
        isSavePending: false
      };
    case `${HOLIDAY_COMPANY_SAVE}_PENDING`:
      return {
        ...state,
        isSavePending: true
      };
    case `${HOLIDAY_COMPANY_SAVE}_REJECTED`:
      return {
        ...state,
        isSavePending: false
      };
    default:
      return state;
  }
}

export default holiday;
